// src/pages/UserWallet.js
import React, { useState, useEffect } from "react";
import { ref, onValue, update } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../utilities/firebaseConfig";

const UserWallet = () => {
  const navigate = useNavigate();
  const [wallet, setWallet] = useState({ balance: 0, referralCode: "" });
  const [referralInput, setReferralInput] = useState("");

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }
    const walletRef = ref(db, `users/${user.uid}/wallet`);
    onValue(walletRef, (snapshot) => {
      if (snapshot.exists()) {
        setWallet(snapshot.val());
      }
    });
  }, [navigate]);

  const handleApplyReferral = async () => {
    const user = auth.currentUser;
    if (!user) return;
    const bonusAmount = 10;
    const newBalance = wallet.balance + bonusAmount;
    await update(ref(db, `users/${user.uid}/wallet`), { balance: newBalance });
    alert(`Referral applied! $${bonusAmount} bonus added.`);
    setReferralInput("");
  };

  return (
    <div>
      <h2>User Wallet</h2>
      <p><strong>Balance:</strong> ${wallet.balance.toFixed(2)}</p>
      <p><strong>Your Referral Code:</strong> {wallet.referralCode || "N/A"}</p>
      <input
        type="text"
        placeholder="Enter referral code"
        value={referralInput}
        onChange={(e) => setReferralInput(e.target.value)}
      />
      <button onClick={handleApplyReferral}>Apply Referral</button>
      <br />
      <button onClick={() => navigate("/dashboard")}>Back to Dashboard</button>
    </div>
  );
};

export default UserWallet;
